import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import EstateMpProvider from "@/core/data-provider/data-mp/estate/estate-mp-provider.ts";
import GameMpProvider from "@/core/data-provider/data-mp/game/game-mp-provider.ts";
import useAppSelector from "@/core/helpers/useAppSelector";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import { estateEnterInfoSelector } from "@/domains/estate/slice";
import toast from "@/domains/toasts/helpers/toast";

export default () => {
  const { t } = useTranslation("estate");
  const estate = useAppSelector(estateEnterInfoSelector);

  const buyEstate = useCallback(async () => {
    try {
      const response = await EstateMpProvider.buy(estate.id);
      if (response instanceof RpcMpProviderFailedResponse) {
        console.error(response);
        toast.error(t("estate.errors.BUY_ERROR"));
      } else {
        console.error(response);
        toast.success(t(`estate.type.${estate.type}.successBuy`));

        GameMpProvider.closeCurrentInterface(true);
      }
    } catch (e) {
      console.error(e);
      toast.error(t("estate.errors.BUY_ERROR"));
    }
  }, [estate, t]);

  return [buyEstate];
};
